export default __webpack_public_path__ + "static/color-picker-avoid-yellow-text-do-d208cb964cf9fc60b329b75035bbe1cf.png";